import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import shopDevcApi from '../../api/shopDevc';
//
import SwbAssetAdvancedSelect from './AssetAdvancedSelect';
Vue.regist(SwbAssetAdvancedSelect);
//
import SwbMerchtGoodsUknoSelect from './MerchtGoodsUknoSelect';
Vue.regist(SwbMerchtGoodsUknoSelect);

export function openAssetAdvancedSelectDlg(dlgConfig, callback) {
    //
    let retailerShopId = dlgConfig['retailerShopId'] || null;
    if(retailerShopId == null) {
        MsgBox.warning("参数错误");
        return;
    }
    let checkBatch = dlgConfig['checkBatch'];
    if(Utils.isNoB(checkBatch)) {
        checkBatch = true;
    }
    let showSingle = dlgConfig['showSingle'];
    if(Utils.isNoB(showSingle)) {
        showSingle = true;
    }
    let showBatch = dlgConfig['showBatch'];
    if(Utils.isNoB(showBatch)) {
        showBatch = true;
    }
    let limitFlag = dlgConfig['limitFlag'];
    if(Utils.isNoB(limitFlag)) {
        limitFlag = true;
    }
    let theDlg = Vue.$showDialog({
        title: '资产-快捷选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: true,
        template: '<div class = "">' +
        '<swb-asset-advanced-select :checkBatch="checkBatch" :retailerShopId="retailerShopId" :warehouseId="warehouseId" :showSingle="showSingle" :showSingleComn="showSingleComn" :showSingleSpecial="showSingleSpecial" :showBatch="showBatch" :showBatchComn="showBatchComn" :showBatchLow="showBatchLow" :showWarehouse="showWarehouse" :showDepart="showDepart" :showGroup="showGroup" :showCat="showCat" :showKind="showKind" :showAcctEnterWay="showAcctEnterWay" :singleFilter="singleFilter" :batchFilter="batchFilter" :dbResultFilter="resultFilter" :limitFlag="limitFlag" ref="swb_advanced_select"></swb-asset-advanced-select>' +
        '</div>',
        data: {
            retailerShopId: retailerShopId,
            warehouseId: dlgConfig['warehouseId'] || null,
            showSingle: showSingle,
            showSingleComn: dlgConfig['showSingleComn'],
            showSingleSpecial: dlgConfig['showSingleSpecial'],
            showBatch: showBatch,
            checkBatch: checkBatch,
            showBatchComn: dlgConfig['showBatchComn'],
            showBatchLow: dlgConfig['showBatchLow'],
            showWarehouse: dlgConfig['showWarehouse'],
            showDepart: dlgConfig['showDepart'],
            showGroup: dlgConfig['showGroup'],
            showCat: dlgConfig['showCat'],
            showKind: dlgConfig['showKind'],
            showAcctEnterWay: dlgConfig['showAcctEnterWay'],
            singleFilter: dlgConfig['singleFilter'],
            batchFilter: dlgConfig['batchFilter'],
            resultFilter: dlgConfig['resultFilter'],
            limitFlag: limitFlag
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_advanced_select.getDlgResult() || {};
            if(result.type == "info") {
                let resultData = result.data;
                let theLoad = MsgBox.loading();
                shopDevcApi.getAssetCount(resultData.resultFilter, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let assetDto = result.data;
                        //
                        if(assetDto.assetCount == 0) {
                            self.$message.warning('所选条件筛选不到资产,请重新勾选过滤条件');
                        } else {
                            if(limitFlag && assetDto.assetCount > 500) {
                                self.$message.warning('资产快捷选择最多支持500个资产，当前' + assetDto.assetCount + "个");
                            } else {
                                resultData.assetCount = assetDto;
                                callback(resultData);
                                theDlg.close();
                            }
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
            return false;
        }
    });
}

import retailerAuthxApi from '../../api/retailerAuthx'
// 设置-分类分组过滤
export function setAssetsGroupDevcFilter(queryConfig, callback, basic = true) {
    let curQueryConfig = queryConfig || {};
    //
    let queryFields = curQueryConfig.queryFields || {};
    let groupDevc = {
        "type": "Select",
        "valueType": "Integer",
        "code": "devcGroupId",
        "label": "分类分组",
        "basic": basic,
        "dataList": [],
        "hidden": false
    };
    let queryConfigMap = queryConfig.queryFields.toMap("code");
    let devcGroup = queryConfigMap['devcGroupId'];
    if(Utils.isNoB(devcGroup)) {
        queryFields.push(groupDevc);
    }
    //
    retailerAuthxApi.getDevcGroupListByContext({}, function (result) {
        if(result.type == 'info') {
            let devcGroupList = result.data;
            //
            let queryConfigMap = queryConfig.queryFields.toMap("code");
            let devcGroup = queryConfigMap['devcGroupId'];
            if(devcGroupList != null && devcGroupList.length > 0) {
                let dataList = [];
                dataList.push({
                    value: null,
                    label: "-全部-"
                });
                for(let i = 0; i < devcGroupList.length; i++) {
                    let devcGroup = devcGroupList[i];
                    dataList.push({
                        value: devcGroup.id,
                        label: devcGroup.name
                    });
                }
                devcGroup.dataList = [];
                devcGroup.dataList = Utils.merge([], dataList);
            } else {
                devcGroup.hidden = true;
            }
            callback(curQueryConfig);
        } else {
            MsgBox.warning(result.message);
        }
    });
}

// 商品标识码选择列表
export function showMerchtGoodsUknoSelectDlg(dlgConfig, callback) {
    let title = dlgConfig["title"] || "商品标识码 - 选择";
    let checkedIds = dlgConfig["checkedIds"] || [];
    let multiSelect = Utils.isTrue(dlgConfig["multiSelect"]);
    let itemId = dlgConfig["itemId"] || null;
    let voucherId = dlgConfig["voucherId"] || null;
    let excludeRetailerId = dlgConfig["excludeRetailerId"] || null;
    let disabledFlag = Utils.isTrue(dlgConfig["disabledFlag"]);
    let returnFlag = Utils.isTrue(dlgConfig["returnFlag"]);
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-mercht-goods-uk-no-select :multiSelect="multiSelect" :checkedIds="checkedIds" :itemId="itemId" :voucherId="voucherId" :excludeRetailerId="excludeRetailerId" :disabledFlag="disabledFlag" :returnFlag="returnFlag" ref="swb_mercht_goods_uk_no_select"></swb-mercht-goods-uk-no-select>',
        data: {
            multiSelect: multiSelect,
            checkedIds: checkedIds,
            itemId: itemId,
            voucherId: voucherId,
            excludeRetailerId: excludeRetailerId,
            disabledFlag: disabledFlag,
            returnFlag: returnFlag
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_mercht_goods_uk_no_select.getDlgResult() || {};
                if(result.type === 'info') {
                    let goodsUknoList = result.data || [];
                    callback(goodsUknoList, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/asset/selectDlg.js
// module id = 33
// module chunks = 0